"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Api_1 = __importDefault(require("./Api"));
class Spaces extends Api_1.default {
    /**
     * @constructor
     */
    constructor(props) {
        super(props);
    }
    /**
     * Archives the workspace. This hides it from navigation, but doesn't do anything other than that.
     * @param space_id
     * @returns
     */
    archive(space_id) {
        const requestObj = {
            method: 'post',
            url: `/space/${space_id}/archive`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Add a new space to an organization.
     * @param attributes
     * @returns
     */
    create(attributes) {
        const requestObj = {
            method: 'post',
            url: `/space/`,
            data: attributes,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Deletes the space with the given id. This will also end all memberships of the space and cancel any space invites still outstanding.
     * @param space_id
     * @returns
     */
    delete(space_id) {
        const requestObj = {
            method: 'delete',
            url: `/space/${space_id}`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Returns the available seats. A null value means there is an unlimited number of available seats.
     * @param space_id
     * @returns
     */
    getAvailableSeats(space_id) {
        const requestObj = {
            method: 'get',
            url: `/space/${space_id}/available`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Returns the available spaces for the given organization. This is spaces that are open and available for the user to join
     * @param org_id
     * @returns
     */
    getAvailableSpaces(org_id) {
        const requestObj = {
            method: 'get',
            url: `/space/org/${org_id}/available/`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Returns the workspaces in the organization that are accesible for the active user.
     * @param org_id
     * @returns
     */
    getOrgSpaces(org_id) {
        const requestObj = {
            method: 'get',
            url: `/space/org/${org_id}/`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Get space data from podio
     *
     * @param {number} space_id
     * @returns
     */
    get(space_id) {
        const requestObj = {
            method: 'get',
            url: `/space/${space_id}`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Get space data from podio
     *
     * @param {number} space_id
     * @returns
     */
    getSpaceByLabel(org_id, label) {
        const requestObj = {
            method: 'get',
            url: `/space/org/${org_id}/url/${label}`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Returns the space and organization with the given full URL.
     * @param attributes
     * @returns
     */
    getSpaceByUrl(attributes) {
        const requestObj = {
            method: 'get',
            url: `/space/url`,
            params: attributes,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Returns the top spaces for the user
     * @returns
     */
    getTopSpaces() {
        const requestObj = {
            method: 'get',
            url: `/space/top/`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Restores an archived workspace. This unhides it from navigation, but doesn't do anything other than that.
     * @param space_id
     * @returns
     */
    restore(space_id) {
        const requestObj = {
            method: 'post',
            url: `/space/${space_id}/restore`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Updates the space with the given id
     * @param space_id
     * @returns
     */
    update(space_id) {
        const requestObj = {
            method: 'put',
            url: `/space/${space_id}`,
        };
        return this._httpRequest(requestObj);
    }
}
exports.default = Spaces;
